import get from 'lodash/get';
import { NOW_PLAYING } from 'src/common/constants/containerTypes';

export default function getNowPlayingContainerItemGuideId(containerItems) {
  const nowPlayingContainerItem = containerItems.find((item) => item.containerType === NOW_PLAYING);
  return get(nowPlayingContainerItem, 'children[0].guideId');
}
